export const OFFER_DATE_PERIODS = [
  { value: "this-week", label: "Esta semana" },
  { value: "last-week", label: "Semana pasada" },
  { value: "this-month", label: "Este mes" },
  { value: "last-month", label: "Mes pasado" },
  { value: "this-year", label: "Este año" },
  { value: "last-year", label: "Año pasado" },
  { value: "custom", label: "Personalizado" },
];

export function toInputDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function startOfDay(date) {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
}

function endOfDay(date) {
  const result = new Date(date);
  result.setHours(23, 59, 59, 999);
  return result;
}

function parseInputDate(value) {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function getOfferDateRange(period, customStart, customEnd, now = new Date()) {
  const today = startOfDay(now);
  let start = new Date(today);
  let end = endOfDay(today);
  switch (period) {
    case "this-week": {
      const weekday = today.getDay() || 7;
      start.setDate(today.getDate() - weekday + 1);
      end = endOfDay(new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6));
      break;
    }
    case "last-week": {
      const weekday = today.getDay() || 7;
      end = endOfDay(new Date(today.getFullYear(), today.getMonth(), today.getDate() - weekday));
      start = startOfDay(new Date(end.getFullYear(), end.getMonth(), end.getDate() - 6));
      break;
    }
    case "this-month":
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = endOfDay(new Date(today.getFullYear(), today.getMonth() + 1, 0));
      break;
    case "last-month":
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = endOfDay(new Date(today.getFullYear(), today.getMonth(), 0));
      break;
    case "this-year":
      start = new Date(today.getFullYear(), 0, 1);
      end = endOfDay(new Date(today.getFullYear(), 11, 31));
      break;
    case "last-year":
      start = new Date(today.getFullYear() - 1, 0, 1);
      end = endOfDay(new Date(today.getFullYear() - 1, 11, 31));
      break;
    case "custom": {
      const parsedStart = parseInputDate(customStart);
      const parsedEnd = parseInputDate(customEnd);
      if (parsedStart && parsedEnd && parsedStart <= parsedEnd) {
        start = startOfDay(parsedStart);
        end = endOfDay(parsedEnd);
      }
      break;
    }
    default:
      break;
  }
  return { start, end };
}
